// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#task-status ul.dropdown-menu {
  margin-top: 0;
  padding: 0;
}

li button.task-action {
  width: 100%;
  border-radius: 0;
}

button.task-action.New {
  width: 140px;
  color: #1161be;
  background-color: #c4deff;
  border: 1px solid #c4deff;
  border-radius: 4px;
}

button.task-action.Assigned {
  width: 140px;
  color: #ca9f00;
  background-color: #fff4cb;
  border: 1px solid #fff4cb;
  border-radius: 4px;
}

button.task-action.Accepted {
  width: 140px;
  color: #1ba953;
  background-color: #daf8e6;
  border: 1px solid #daf8e6;
  border-radius: 4px;
}

button.task-action.OnRoute {
  width: 140px;
  color: #1ba953;
  background-color: #daf8e6;
  border: 1px solid #daf8e6;
  border-radius: 4px;
}

button.task-action.OnHold {
  width: 140px;
  color: #1ba953;
  background-color: #daf8e6;
  border: 1px solid #daf8e6;
  border-radius: 4px;
}

button.task-action.Processing {
  width: 140px;
  color: #1ba953;
  background-color: #daf8e6;
  border: 1px solid #daf8e6;
  border-radius: 4px;
}

button.task-action.Done {
  width: 140px;
  color: #1ba953;
  background-color: #daf8e6;
  border: 1px solid #daf8e6;
  border-radius: 4px;
}

button.task-action.Rejected {
  width: 140px;
  color: #f64540;
  background-color: #ffd5e0;
  border: 1px solid #ffd5e0;
  border-radius: 4px;
}

button.task-action.Failed {
  width: 140px;
  color: #f64540;
  background-color: #ffd5e0;
  border: 1px solid #ffd5e0;
  border-radius: 4px;
}

button.task-action.OnSite {
  width: 140px;
  color: #ff9800;
  background-color: #ffe0b2;
  border: 1px solid #ffe0b2;
  border-radius: 4px;
}

button.task-action.Completed {
  width: 140px;
  color: #4caf50;
  background-color: #e8f5e9;
  border: 1px solid #e8f5e9;
  border-radius: 4px;
}

button.task-action.Driver.Arrived, button.task-action.DriverArrived {
  width: 140px;
  color: #ca9f00;
  background-color: #fff4cb;
  border: 1px solid #fff4cb;
  border-radius: 4px;
}

button.task-action.Review, button.task-action.Review {
  width: 140px;
  color: #faac03;
  background-color: #fffacb;
  border: 1px solid #fffacb;
  border-radius: 4px;
}

button.task-action.Archived {
  width: auto;
}

.task-column.side {
  width: 357px;
}

.btn-outline-primary:hover {
  color: white !important;
}

.progress-content {
  padding: 23px 27px;
}

::ng-deep .modal-container {
  position: absolute;
  background-color: #fff;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
}

.rating {
  font-size: xx-large;
  color: #8291ae;
  background: #f7f8fc;
  line-height: 29px;
  margin: 0 auto 0 10px;
  padding: 0 5px;
  border-radius: 4px;
  height: 33px;
}

.customer-feedback {
  padding: 5px 15px;
  border-radius: 4px;
  margin: 0 10px;
}

.customer-feedback > span {
  font-weight: 700;
}

.customer-feedback.accepted {
  color: #1ba953;
  background-color: #daf8e6;
  border: 1px solid #daf8e6;
}

.customer-feedback.unaccepted {
  color: #f64540;
  background-color: #ffd5e0;
  border: 1px solid #ffd5e0;
}

.has-danger {
  border-color: #d9534f;
}

.user-rate {
  height: 45px;
  vertical-align: middle;
  margin: 5px 0;
  padding: 5px;
}
.user-rate span,
.user-rate i-feather {
  color: #1161be;
}
.user-rate span {
  font-weight: bold;
  font-size: small;
  vertical-align: middle;
}
.user-rate ngb-rating {
  float: right;
}`, "",{"version":3,"sources":["webpack://./src/app/tasks/task-view/task-view.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,UAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;AACF;;AAUA;EAPE,YAAA;EACA,cAO0B;EAN1B,yBAMmC;EALnC,yBAAA;EACA,kBAAA;AACF;;AAMA;EAXE,YAAA;EACA,cAW0B;EAV1B,yBAUmC;EATnC,yBAAA;EACA,kBAAA;AASF;;AAEA;EAfE,YAAA;EACA,cAe0B;EAd1B,yBAcmC;EAbnC,yBAAA;EACA,kBAAA;AAiBF;;AAFA;EAnBE,YAAA;EACA,cAmB0B;EAlB1B,yBAkBmC;EAjBnC,yBAAA;EACA,kBAAA;AAyBF;;AANA;EAvBE,YAAA;EACA,cAuB0B;EAtB1B,yBAsBmC;EArBnC,yBAAA;EACA,kBAAA;AAiCF;;AAVA;EA3BE,YAAA;EACA,cA2B0B;EA1B1B,yBA0BmC;EAzBnC,yBAAA;EACA,kBAAA;AAyCF;;AAdA;EA/BE,YAAA;EACA,cA+B0B;EA9B1B,yBA8BmC;EA7BnC,yBAAA;EACA,kBAAA;AAiDF;;AAlBA;EAnCE,YAAA;EACA,cAmC0B;EAlC1B,yBAkCmC;EAjCnC,yBAAA;EACA,kBAAA;AAyDF;;AAtBA;EAvCE,YAAA;EACA,cAuC0B;EAtC1B,yBAsCmC;EArCnC,yBAAA;EACA,kBAAA;AAiEF;;AA3BA;EA1CE,YAAA;EACA,cA0C0B;EAzC1B,yBAyCmC;EAxCnC,yBAAA;EACA,kBAAA;AAyEF;;AAhCA;EA7CE,YAAA;EACA,cA6C0B;EA5C1B,yBA4CmC;EA3CnC,yBAAA;EACA,kBAAA;AAiFF;;AArCA;EAhDE,YAAA;EACA,cAgD0B;EA/C1B,yBA+CmC;EA9CnC,yBAAA;EACA,kBAAA;AAyFF;;AA1CA;EAnDE,YAAA;EACA,cAmD0B;EAlD1B,yBAkDmC;EAjDnC,yBAAA;EACA,kBAAA;AAiGF;;AA9CA;EACE,WAAA;AAiDF;;AA9CA;EACE,YAAA;AAiDF;;AA/CA;EACE,uBAAA;AAkDF;;AA/CA;EACE,kBAAA;AAkDF;;AA9CE;EACE,kBAAA;EACA,sBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;AAiDJ;;AA9CA;EACE,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;EACA,qBAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;AAiDF;;AA/CA;EACE,iBAAA;EACA,kBAAA;EACA,cAAA;AAkDF;;AAhDA;EACE,gBAAA;AAmDF;;AAjDA;EACE,cAAA;EACA,yBAAA;EACA,yBAAA;AAoDF;;AAlDA;EACE,cAAA;EACA,yBAAA;EACA,yBAAA;AAqDF;;AAlDA;EACE,qBAAA;AAqDF;;AAlDA;EACE,YAAA;EACA,sBAAA;EACA,aAAA;EACA,YAAA;AAqDF;AApDE;;EAEE,cAAA;AAsDJ;AApDE;EACE,iBAAA;EACA,gBAAA;EACA,sBAAA;AAsDJ;AApDE;EACE,YAAA;AAsDJ","sourcesContent":["#task-status ul.dropdown-menu {\n  margin-top: 0;\n  padding: 0;\n}\n\nli button.task-action {\n  width: 100%;\n  border-radius: 0;\n}\n\n@mixin taskActionButton($color, $bgColor) {\n  width: 140px;\n  color: $color;\n  background-color: $bgColor;\n  border: 1px solid $bgColor;\n  border-radius: 4px;\n}\n\nbutton.task-action.New {\n  @include taskActionButton(#1161be, #c4deff);\n}\n\nbutton.task-action.Assigned {\n  @include taskActionButton(#ca9f00, #fff4cb);\n}\n\nbutton.task-action.Accepted {\n  @include taskActionButton(#1ba953, #daf8e6);\n}\n\nbutton.task-action.OnRoute {\n  @include taskActionButton(#1ba953, #daf8e6);\n}\n\nbutton.task-action.OnHold {\n  @include taskActionButton(#1ba953, #daf8e6);\n}\n\nbutton.task-action.Processing {\n  @include taskActionButton(#1ba953, #daf8e6);\n}\n\nbutton.task-action.Done {\n  @include taskActionButton(#1ba953, #daf8e6);\n}\n\nbutton.task-action.Rejected {\n  @include taskActionButton(#f64540, #ffd5e0);\n}\n\nbutton.task-action.Failed {\n  @include taskActionButton(#f64540, #ffd5e0);\n}\nbutton.task-action.OnSite {\n  @include taskActionButton(#ff9800, #ffe0b2);\n}\nbutton.task-action.Completed {\n  @include taskActionButton(#4caf50, #e8f5e9);\n}\nbutton.task-action.Driver.Arrived, button.task-action.DriverArrived {\n  @include taskActionButton(#ca9f00, #fff4cb);\n}\nbutton.task-action.Review, button.task-action.Review {\n  @include taskActionButton(#faac03, #fffacb);\n}\n\nbutton.task-action.Archived {\n  width: auto;\n}\n\n.task-column.side {\n  width: 357px;\n}\n.btn-outline-primary:hover {\n  color: white !important;\n}\n\n.progress-content {\n  padding: 23px 27px;\n}\n\n::ng-deep {\n  .modal-container {\n    position: absolute;\n    background-color: #fff;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 1;\n  }\n}\n.rating {\n  font-size: xx-large;\n  color: #8291ae;\n  background: #f7f8fc;\n  line-height: 29px;\n  margin: 0 auto 0 10px;\n  padding: 0 5px;\n  border-radius: 4px;\n  height: 33px;\n}\n.customer-feedback{\n  padding: 5px 15px;\n  border-radius: 4px;\n  margin: 0 10px;\n}\n.customer-feedback > span {\n  font-weight: 700;\n}\n.customer-feedback.accepted{\n  color: #1ba953;\n  background-color: #daf8e6;\n  border: 1px solid #daf8e6;\n}\n.customer-feedback.unaccepted{\n  color: #f64540;\n  background-color: #ffd5e0;\n  border: 1px solid #ffd5e0;\n}\n\n.has-danger {\n  border-color: #d9534f;\n}\n\n.user-rate {\n  height: 45px;\n  vertical-align: middle;\n  margin: 5px 0;\n  padding: 5px;\n  span,\n  i-feather {\n    color: #1161be;\n  }\n  span {\n    font-weight: bold;\n    font-size: small;\n    vertical-align: middle;\n  }\n  ngb-rating {\n    float: right;\n  }\n\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
